import Typography from '@mui/material/Typography';
import React from 'react';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';
import { SurveySelectOption } from 'shared/types/survey-select-option';

import * as Styled from './survey.style';
import { SurveyOption } from './survey-option';

export type SurveySingleSelectStepProps = {
  title: string;
  subtitle?: string;
  options: SurveySelectOption[];
  backLabel: string;
  onBack: () => void;
  skipLabel?: string;
  onSkip?: () => void;
};

export const SurveySingleSelectStep: React.FC<SurveySingleSelectStepProps> = ({
  title,
  subtitle,
  options,
  backLabel,
  onBack,
  skipLabel,
  onSkip,
}) => (
  <>
    <Styled.Header>
      <Typography variant="h5" component="h1">
        {title}
      </Typography>
      {subtitle ? (
        <Styled.Subtitle>
          <Typography variant="body2">{subtitle}</Typography>
        </Styled.Subtitle>
      ) : null}
    </Styled.Header>

    <Styled.Body>
      <Styled.OptionList>
        {options.map((option) => (
          <SurveyOption
            key={option.key}
            label={option.label}
            selected={option.selected}
            onClick={option.onClick}
          />
        ))}
      </Styled.OptionList>
    </Styled.Body>

    <Styled.Interactions>
      <Button
        variant={Variants.Contained}
        size={Sizes.Medium}
        color={Colors.TextPrimary}
        onClick={onBack}
      >
        {backLabel}
      </Button>
      {skipLabel && onSkip ? (
        <Button
          variant={Variants.Text}
          size={Sizes.Medium}
          color={Colors.Inherit}
          onClick={onSkip}
        >
          {skipLabel}
        </Button>
      ) : null}
    </Styled.Interactions>
  </>
);
